/** The single predicate the whole app keys off of. */
export function hasContentAccess(user) {
    return user.accessStatus === 'active';
}
/** Instructors administer the platform; they are not content-gated. */
export function isInstructor(user) {
    return user.role === 'instructor';
}
/**
 * Resolve what a signed-in user should see. Instructors are always allowed
 * (they manage access). Students are gated on their accessStatus.
 */
export function resolveGate(user) {
    if (isInstructor(user)) {
        return {
            state: 'allowed',
            allowed: true,
            title: 'Instructor access',
            message: 'You have full instructor access.',
        };
    }
    return gateForStatus(user.accessStatus);
}
export function gateForStatus(status) {
    switch (status) {
        case 'active':
            return {
                state: 'allowed',
                allowed: true,
                title: 'Membership active',
                message: 'Your membership is active. Welcome back.',
            };
        case 'pending':
            return {
                state: 'pending',
                allowed: false,
                title: 'Membership pending',
                message: 'Your account is created but not yet activated. Once we confirm your ' +
                    'payment, your instructor will grant access and your course will unlock.',
            };
        case 'revoked':
            return {
                state: 'revoked',
                allowed: false,
                title: 'Access paused',
                message: 'Your access is currently paused. Please contact your instructor to ' +
                    'restore your membership.',
            };
        default: {
            // Exhaustiveness guard — a new AccessStatus must be handled here.
            const _never = status;
            return _never;
        }
    }
}
/** Whether a user may reach instructor-only (admin) surfaces. */
export function canAccessAdmin(user) {
    return isInstructor(user);
}
/** Valid manual transitions the instructor can perform in Learners & Access. */
const ALLOWED_TRANSITIONS = {
    pending: ['active', 'revoked'],
    active: ['revoked'],
    revoked: ['active'],
};
export function canTransitionAccess(from, to) {
    return ALLOWED_TRANSITIONS[from].includes(to);
}
/** Human label for the instructor's action button per current status. */
export function accessActionLabel(status) {
    switch (status) {
        case 'pending':
            return 'Confirm & grant';
        case 'active':
            return 'Revoke';
        case 'revoked':
            return 'Restore';
    }
}
export const ROLES = ['student', 'instructor'];
export const ACCESS_STATUSES = ['pending', 'active', 'revoked'];
//# sourceMappingURL=access.js.map